import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.verify', {
        url: '/verify',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsVerify'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/verify/send-verification-emails.state.js